import { render, staticRenderFns } from "./EventCarousel.vue?vue&type=template&id=3d0ff468&"
import script from "./EventCarousel.vue?vue&type=script&lang=ts&"
export * from "./EventCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./EventCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarouselItem})
